<template>
  <div>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <Table
        border
        stripe
        ref="table"
        :loading="loading"
        :columns="columns"
        :data="data"
        highlight-row
        @on-row-click="rowClick"
      >
      </Table>
      <Row style="margin-top:15px">
        <Col span="19">
          <Page
            :total="total"
            :page-size="pageInfo.pageSize"
            @on-change="pageChange"
          />
        </Col>
      </Row>
    </Card>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <p slot="title">教育背景信息</p>
      <Form
        style="margin: 30px 20px"
        :model="formItem"
        :label-width="150"
        inline
        label-position="left"
        :disabled="disableSelfData.EducationBackground"
        v-if="showSelfData.EducationBackground == '1'"
      >
        <FormItem
          :label="lang == 'zh' ? chNameMap[val] : enNameMap[val]"
          v-for="(val, key) in sortfMap"
          :key="val"
          style="margin-right: 50px;"
          v-if="showSelfData[val] == '1'"
        >
          <DatePicker
            v-if="val == 'programstartdate' || val == 'graduatedate'"
            type="date"
            v-model="formItem[val]"
            style="min-width: 260px"
            :disabled="disableSelfData[val] == 0"
          ></DatePicker>
          <Select
            v-else-if="
              val == 'school' ||
                val == 'major' ||
                val == 'degree' ||
                val == 'academicdegree'
            "
            :clearable="true"
            v-model="formItem[val]"
            style="min-width: 260px;"
            :disabled="disableSelfData[val] == 0"
          >
            <Option
              v-for="item in val == 'school'
                ? SCHOOL
                : val == 'major'
                ? MAJOR
                : val == 'degree'
                ? DEGREE
                : ACADEMICDEGREE"
              :value="item.code"
              :key="item.code"
              :label="item.name"
            ></Option>
          </Select>
          <Checkbox
            v-else-if="val == 'highest' || val == 'graduate'"
            v-model="formItem[val]"
            :disabled="disableSelfData[val] == 0"
          ></Checkbox>
          <Input
            v-else
            v-model="formItem[val]"
            style="min-width: 260px;"
            :disabled="disableSelfData[val] == 0"
          />
        </FormItem>
      </Form>
    </Card>
    <div class="bottomBtn">
      <Button
        type="primary"
        @click="saveData()"
        :disabled="disableSelfData.EducationBackground"
        >保存</Button
      >
      <Button v-if="plan" @click="returnPage()" style="margin-left: 15px"
        >返回</Button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../../../src/util/DateUtil";
import ExpressionUtil from "../../../../util/ExpressionUtil";
import watermark from "@/util/watermark";

export default {
  data() {
    return {
      date: new DateUtil(),
      formItem: {},
      workStatus: [
        {
          value: "现职",
          label: "现职"
        }
      ],
      data: [],
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 1,
      loading: false,
      disableSelfData: {},
      showSelfData: {},
      chNameMap: {},
      enNameMap: {},
      SCHOOL: [],
      MAJOR: [],
      ACADEMICDEGREE: [],
      id: null,
      plan: null,
      userId: "",
      index: null,
      sortfMap: {}
    };
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userId = userInfo.serialnumber;
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    getWaterMarkStatus() {
      return this.$store.getters.getWaterMarkStatus == 1
        ? watermark.addWaterMark()
        : "";
    },
    columns() {
      let column = [
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.programstartdate
              : this.enNameMap.programstartdate,
          key: "programstartdate",
          align: "center",
          minWidth: 160,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.programstartdate, "YYYY/MM/DD")
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.graduatedate
              : this.enNameMap.graduatedate,
          key: "graduatedate",
          align: "center",
          minWidth: 160,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.graduatedate, "YYYY/MM/DD")
            );
          }
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.school : this.enNameMap.school,
          key: "school",
          align: "center",
          minWidth: 160,
          render: (h, params) => {
            return h(
              "span",
              this.SCHOOL.filter(item => item.code == params.row.school).map(
                res => res.name
              )
            );
          }
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.major : this.enNameMap.major,
          key: "major",
          align: "center",
          minWidth: 160,
          render: (h, params) => {
            return h(
              "span",
              this.MAJOR.filter(item => item.code == params.row.major).map(
                res => res.name
              )
            );
          }
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.degree : this.enNameMap.degree,
          key: "degree",
          align: "center",
          minWidth: 160,
          render: (h, params) => {
            return h(
              "span",
              this.DEGREE.filter(item => item.code == params.row.degree).map(
                res => res.name
              )
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.academicdegree
              : this.enNameMap.academicdegree,
          key: "academicdegree",
          align: "center",
          minWidth: 160,
          render: (h, params) => {
            return h(
              "span",
              this.ACADEMICDEGREE.filter(
                item => item.code == params.row.academicdegree
              ).map(res => res.name)
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.programyears
              : this.enNameMap.programyears,
          key: "programyears",
          align: "center",
          minWidth: 160
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.comment : this.enNameMap.comment,
          key: "comment",
          align: "center",
          minWidth: 160
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.highest : this.enNameMap.highest,
          key: "highest",
          align: "center",
          minWidth: 160,
          render: (h, params) => {
            let highest1 = params.row.highest;
            if (highest1 == 1) {
              highest1 = "是";
            } else {
              highest1 = "否";
            }
            return h("span", highest1);
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.graduate
              : this.enNameMap.graduate,
          key: "graduate",
          align: "center",
          minWidth: 160,
          render: (h, params) => {
            let graduate1 = params.row.graduate;
            if (graduate1 == 1) {
              graduate1 = "是";
            } else {
              graduate1 = "否";
            }
            return h("span", graduate1);
          }
        }
      ];
      let arr = [];
      arr = column.filter(item => {
        return this.showSelfData[item.key] == 1;
      });
      return arr;
    }
  },
  methods: {
    getData(id, plan) {
      this.plan = plan ? plan : "";
      this.id = id;
      this.getTableData();
    },
    getTableData() {
      this.formItem.highest = 0;
      this.formItem.graduate = 0;
      let obj = {
        sheetId: this.id,
        serialnumber: this.plan ? this.plan : this.userId,
        bePersonal: this.plan ? "0" : "1",
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize
      };
      this.loading = true;
      axios.post("/EducationBack/researchUserEduBackInfo", obj).then(res => {
        this.loading = false;
        if (res) {
          this.data = res.data;
          this.total = Number(res.pageInfo.total);
          this.showSelfData = res.showSelfData;
          this.disableSelfData = res.disableSelfData;
          this.chNameMap = res.chNameMap;
          this.enNameMap = res.enNameMap;
          this.disableSelfData.EducationBackground =
            this.disableSelfData.EducationBackground == 0 ? true : false;
          this.SCHOOL = res.optionData.SCHOOL;
          this.MAJOR = res.optionData.MAJOR;
          this.DEGREE = res.optionData.DEGREE;
          this.ACADEMICDEGREE = res.optionData.ACADEMICDEGREE;
          this.sortfMap = res.sortfMap;
          delete this.sortfMap[9];
          // this.$set(this.formItem , 'graduate', this.formItem.graduate == "1" ? "是" : "否")
        }
      });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getTableData();
    },
    rowClick(row, index) {
      this.formItem = row;
      this.index = index;
    },
    saveData() {
      // this.formItem.graduate = this.formItem.graduate == "是" ? "1" : "0"
      let flag = 0;
      if (this.formItem.highest == "1") {
        this.data.forEach((item, index) => {
          if (item.highest == "1" && index != this.index) {
            flag = 1;
          }
        });
        if (flag == "1") {
          this.$Message.error("只允许有一条最高学历！");
          flag = 0;
          return;
        }
      }
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        content: "",
        onOk: () => {
          let obj = {
            serialnumber: this.plan,
            ...this.formItem
          };
          axios
            .post("/EducationBack/rollBackUserEduBackInfo", obj)
            .then(res => {
              if (res) {
                this.getTableData();
                this.$Message.info(res);
                this.formItem = {
                  highest: 0,
                  graduate: 0
                };
              }
            });
        },
        onCancel: () => {}
      });
    },
    returnPage() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.formCol {
  width: calc((100% - 210px) / 3);
  float: left;
  /* margin-right: 30px; */
}
@media screen and (max-width: 1300px) and (min-width: 800px) {
  .formCol {
    width: calc((100% - 40px) / 2);
  }
}
@media screen and (max-width: 800px) {
  .formCol {
    width: 100%;
  }
}
.bottomBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.ivu-date-picker {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/components/EducationBackground.vue